<template id="Gateway">
  <v-ons-page id="GatewayPage">
    <v-ons-row>
      <v-ons-col>
        <img src="../assets/img/logo.png" width="200px" style="margin:20px; padding-top:10px">
        <h3 class="entrar">Você é maior de 18 anos?</h3>
        <v-ons-button modifier="transparent" class="btnGateway" @click="openCadastroo()">Sim</v-ons-button>  
        <v-ons-button modifier="transparent" class="btnGateway" @click="showDialog()">Não</v-ons-button>  
        <h3 style="font-size:12px; margin-top:25px;" class=" book">Ao clicar em Sim você aceita nossos<br>
        <a 
          style="margin:auto;"
          target="_blank"
          href="https://hnk00.cyma.digital/termos-de-uso">
          <b>Termos e Condições</b>.</a></h3>
        <!-- <h3 class="textoCPF book" style="margin-top:30px;">Desculpe mas você precisa ser maior de 18 anos para acessar esse site</h3>         -->
      </v-ons-col>
    </v-ons-row>

    <ons-dialog id="dialog-idade">
      <div style="text-align: center; padding: 10px;">
        <p>Desculpe mas você precisa ser maior de 18 anos para acessar esse site.</p>
        <v-ons-button modifier="transparent" class="btnGateway" @click="hideDialog()">Fechar</v-ons-button> 
      </div>
    </ons-dialog>

  </v-ons-page>
</template>
<style>
.select-input {font-size:15px !important}
h1, h2, h3, h4, h5, h6 {font-family: 'Uni Sans' !important}
.entrar {font-size: 25px !important;
}
.facalogin {font-size: 19px;
    margin: 39px !important;}
.botaoface {
    position: relative;
    background: #4267b2 !important;
    color: #fff !important;
    padding: 6px 9px !important;
    font-size: 15px !important;
    width: 90%;
    border-radius: 30px !important;
    font-family: 'Uni Sans' !important;
    margin:10px !important;
}
.botaogoogle {
    position: relative;
    background: #fff !important;
    color: #353535 !important;
    padding: 6px 9px !important;
    font-size: 15px !important;
    width: 90%;
    border-radius: 30px !important;
    font-family: 'Uni Sans' !important;
    margin: 10px !important;
}
#GatewayPage .textoCPF {font-size: 18px !important;
}
#GatewayPage .datadenascimento {font-size: 20px !important;
}
#GatewayPage ons-input {
    display: inline-block;
    position: relative;
    width: 86%;
    margin-left:30px;
    margin-right:30px;
}
#GatewayPage ons-input .text-input, ons-search-input .search-input {
    width: 100%;
    display: inline-block;
    height: 40px;
}
#GatewayPage .text-input--material__label--active{
    display:none;
}
#GatewayPage .list-item--material {
    border: 0;
    padding: 0 0 0 30px;
    line-height: normal;
}
#GatewayPage .list-item--material__left {
    padding: 14px 0;
    min-width: 34px;
    line-height: 1;
    min-height: 48px;
}
#GatewayPage .list-item--material__center { 
    background:none !important;
}
#GatewayPage .text-input--material__label {
    font-family: 'Roboto', 'Noto', sans-serif;
    -webkit-font-smoothing: antialiased;
    font-weight: 400;
    color: #afafaf;
    position: absolute;
    left: 2px;
    top: 2px;
    font-size: 18px;
    font-weight: 400;
    pointer-events: none;
    /* height: 66px; */
    padding-top: 4px;
}
</style>
<script>

import QuizVue from './Quiz.vue';
import LoginVue from './Login.vue';
export default {
  name: 'Gateway',
  key: 'Gateway',
  data() {
    return {
      input: {
        flGeladeira: false,
        flVending: false
      }
    };
  },
  props: ['pageStack'],
  mounted() { 
    var args = window.location.href.split("/");
    window.console.log(args)
    window.debugger
    if ((args[args.length-1] == "geladeira") || (args[args.length-2] == "geladeira")) {
        this.input.flGeladeira = true
    }    
    if ((args[args.length-1] == "vend") || (args[args.length-2] == "vend")) {
        this.input.flVending = true
    }
    localStorage.setItem("action", JSON.stringify(this.input))
  },
  methods: {
    openCadastroo() { 
      if (this.input.flGeladeira || this.input.flVending) { 
        this.$emit("push", LoginVue)
      }
      else { 
        this.$emit("push", QuizVue)
      }
    }, 
    back(){ 
      // window.location("https://www.cymadigital.com.br")
    },
    showDialog() {
      var dialog = document.getElementById('dialog-idade');

      if (dialog) {
        dialog.show();
      }
    },
    hideDialog() {
      var dialog = document.getElementById('dialog-idade');
      dialog.hide();

      // location.replace("https://www.cymadigital.com.br")
    }
  }
}
</script>